/* eslint-disable @repo/internal/react/require-jsdoc */
import { createContext } from 'react';
export var TabContext = /*#__PURE__*/createContext(null);
export var TabListContext = /*#__PURE__*/createContext(null);
export var TabPanelContext = /*#__PURE__*/createContext(null);